
<template>
   <div>
      <div style="margin-left:50px;">
        
          <el-form style="display: flex;flex-wrap: wrap;">
              <el-form-item label="假期类型:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择假期类型" v-model="input1" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="请假包含时间:" style="display: flex;width: 33%;" >
                  <el-date-picker  v-model="input2"   value-format="yyyy-MM-dd" type="date"  placeholder="选择日期">
                  </el-date-picker>
              </el-form-item>

              <el-form-item label="申请人:" style="display: flex;width: 33%;">
                  <el-input v-model="input3" placeholder="请输入内容"></el-input>
              </el-form-item>

              <el-form-item label="审批状态:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择审批状态" v-model="input4" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="申请时间:" style="display: flex;width: 65%;" >
                  <el-date-picker  style="width: 100%;"   v-model="input5"  type="daterange"  value-format="yyyy-MM-dd"  range-separator="至"  start-placeholder="开始日期"   end-placeholder="结束日期"   clearable>  </el-date-picker>
              </el-form-item>

              <el-form-item label="所属部门:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择所属部门" v-model="input6" style="width: 100%" clearable filterable>
                      <el-option   v-for="item in optionList7"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                  <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
              </div>

          </el-form>


          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
              <el-table-column prop="createName" label="申请时间" show-overflow-tooltip></el-table-column>
              <el-table-column prop="createTime" label="申请人" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="所属部门" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="请假类型" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="请假开始时间" show-overflow-tooltip width="110"></el-table-column>
              <el-table-column prop="name" label="请假结束时间" show-overflow-tooltip width="110"></el-table-column>
              <el-table-column prop="name" label="时长" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="请假事由" show-overflow-tooltip width="100">
                <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;color:#00aaff;" @click="handleClickView('请假事由', scope.row.name)">{{ scope.row.name }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="审批完成时间" show-overflow-tooltip width="110"></el-table-column>
              <el-table-column prop="isDelete" label="审批状态" show-overflow-tooltip>
                <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;color:#00aaff;" v-if="scope.row.isDelete === 1">已通过</div>
                      <div style="display: flex;justify-content: space-around;color:rgb(255 151 0);" v-if="scope.row.isDelete === 2">审批中</div>
                      <div style="display: flex;justify-content: space-around;color:rgb(255 54 0);" v-if="scope.row.isDelete === 3">已拒接</div>
                </template>
              </el-table-column>
              <el-table-column label="审批流程" fixed="right" width="150">
                  <template slot-scope="scope">
                      <div style="display: flex;justify-content: space-around;">
                          <el-button type="text" style="color:#00aaff;" @click="handleClickView('审批流程', scope.row)">查看</el-button>
                      </div>
                  </template>
              </el-table-column>
          </el-table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>




        <div class="box"  v-if="ShowAddTemplateDialog">

          <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;">
              <div style="text-align: end; padding-right: 20px; padding-top: 10px; font-size: 26px;" @click="handleShowAddTemplateDialogClose"><i class="el-icon-close"></i> </div>
              <div style="font-size:20px;font-weight: 900;margin-bottom: 10px;margin-bottom:20px;">{{ShowAddTemplateDialogTltie}}</div>
          </div>

          <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;display: flex;">
            <div style="width:20%;border-right: 2px solid #EBEEF5;overflow-y: auto;">
                  <div style="margin-top: 10px;padding-top: 10px;"><el-button :disabled="disabled" style="width: 80%;height: 35px;line-height: 2px;" type="primary" plain @click="handleAddCilckTemplate('邮箱模版')">邮箱模版</el-button></div>
            </div>
            <div style="width:80%;overflow: auto;" :class="disabled ? 'no-click' : '' ">
                <vue-components  v-if="showComponents" v-model="content"></vue-components>
            </div>
          </div>

          <div style="border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
              <span slot="footer" class="dialog-footer">
                  <el-button size="small"  @click="handleShowAddTemplateDialogClose">取 消</el-button>
                  <el-button size="small" v-if="!disabled"  type="primary" @click="handleShowAddTemplateDialogSub">确 定</el-button>
              </span>
          </div>

        </div>
        



        <el-dialog width="60%" style="padding: 0px 50px;" :visible.sync="showPopUpNotification" :before-close="showPopUpNotificationCler" :close-on-click-modal="false">

              <div style="text-align: start;">
                  <div style="margin-bottom: 10px;">学员: 滕家俊</div>
                  <div style="margin-bottom: 10px;">联系电话: 13797468399</div>
                  <div style="margin-bottom: 10px;">沟通时间: 2024-5-29 16:00-16:30</div>
                  <div style="margin-bottom: 10px;">沟通教师: 单老师</div>
                  <div style="margin-bottom: 10px;">助理: 小张</div>
                  <div style="margin-bottom: 10px;">创建代办时间: 2024-5-29 16:00</div>
              </div>
              <el-divider></el-divider>
              <div>
                  <h3 style="margin-bottom: 10px;">沟通内容</h3>
                  <div style="text-indent: 66px;text-align: start;">英语，首次课后，考虑到孩子的知识基础和接受能力，课上能讲解和补充的知识点有限。后续会跟进学校进度讲解课本上的知识点，
                      复习已学习的知识点，针对学生薄弱的题型进行练习并讲解。但考虑到后续仍需讲解和练习的内容，孩子的学习基础和接受能力等，
                      仍可能发生期末考试成绩不理想的情况。
                  </div>
              </div>
              <el-divider></el-divider>
              <div>
                  <h3 style="margin-bottom: 20px;">助理待办</h3>
                  <i class="el-icon-circle-check" style="color: #58d61a; font-size: 80px; position: absolute;  right: 30px; margin-top: -50px;" v-if="isDisabled"></i>
                  <div style="display: flex;margin-bottom: 20px;">
                     <div style="margin-top: 10px;" :style="{ paddingRight: isDisabled ? '23px' : '10px' }">{{ isDisabled  ? '待办人' : '选择人员' }}:</div>
                     <div>
                        <el-select :disabled="isDisabled" placeholder="请选择助理" v-model="value1" style="width: 100%" clearable filterable>
                          <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                        </el-select>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;">
                     <div style="margin-top: 10px;padding-right: 10px;">待办内容:</div>
                     <div style="width: 85%;">
                       <el-input :disabled="isDisabled" type="textarea"  placeholder="请输入内容"  v-model="textarea1" maxlength="200" :autosize="{ minRows: 6, maxRows: 6 }"  show-word-limit></el-input>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;">
                     <div style="margin-top: 5px;padding-right: 10px;">{{ isDisabled  ? '附件' : '上传附件' }}:</div>
                     <div style="" v-if="!isDisabled">
                        <el-button type="primary" size="small" @click="handleUptaFlie(1)">请选择附件<i class="el-icon-upload el-icon--right"></i></el-button>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;" v-if=" FileLists1 && FileLists1.length > 0">
                     <div style="margin-left: 11%;" v-for="(itme,index) in FileLists1" :key="index">
                        <div style="margin-bottom: 20px;margin-top: 20px;">
                            <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                            <i style="color: #f31341;" class="el-icon-close" @click="handleDelet(itme,index,1)"></i>
                        </div>
                     </div>
                  </div>
                  <div style="margin-bottom: 20px; background: #e9e9e9; margin-top: 30px;text-align: start; padding: 10px;" v-if="isDisabled">
                      <div style="margin-top: 10px;">
                        <div>办理结果:  我已完成了，后续麻烦继续跟进一下。</div>
                      </div>
                      <div style="margin-top: 10px;">
                        <div>回执附件:</div>
                        <div style="margin-left: 11%;" v-for="(itme,index) in FileLists11" :key="index">
                            <div style="margin-bottom: 20px;margin-top: 20px;">
                                <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                            </div>
                        </div>
                      </div>
                      <div style="margin-top: 10px;text-align: end;">
                        <div>处理时间: </div>
                        <div>2024-5-29 16:00</div>
                        <div>2024-5-29 16:00</div>
                      </div>
                  </div>
              </div>
              <el-divider></el-divider>
              <div>
                  <h3 style="margin-bottom: 20px;">销售待办</h3>
                  <i class="el-icon-time" style="color: rgb(241 167 35); font-size: 80px; position: absolute;  right: 30px; margin-top: -50px;" v-if="isDisabled"></i>
                  <div style="display: flex;margin-bottom: 20px;">
                     <div style="margin-top: 10px;" :style="{ paddingRight: isDisabled ? '23px' : '10px' }">{{ isDisabled  ? '待办人' : '选择人员' }}:</div>
                     <div>
                        <el-select :disabled="isDisabled" placeholder="请选择助理" v-model="value2" style="width: 100%" clearable filterable>
                          <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                        </el-select>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;">
                     <div style="margin-top: 10px;padding-right: 10px;">待办内容:</div>
                     <div style="width: 85%;">
                       <el-input :disabled="isDisabled"  type="textarea"  placeholder="请输入内容"  v-model="textarea2" maxlength="200" :autosize="{ minRows: 6, maxRows: 6 }"  show-word-limit></el-input>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;">
                     <div style="margin-top: 5px;padding-right: 10px;">{{ isDisabled  ? '附件' : '上传附件' }}:</div>
                     <div style=""  v-if="!isDisabled">
                        <el-button type="primary" size="small" @click="handleUptaFlie(2)">请选择附件<i class="el-icon-upload el-icon--right"></i></el-button>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;" v-if=" FileLists2 && FileLists2.length > 0">
                     <div style="margin-left: 11%;" v-for="(itme,index) in FileLists2" :key="index">
                        <div style="margin-bottom: 20px;margin-top: 20px;">
                            <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                            <i style="color: #f31341;" class="el-icon-close" @click="handleDelet(itme,index,2)"></i>
                        </div>
                     </div>
                  </div>

                  <div style="margin-bottom: 20px; background: #e9e9e9; margin-top: 30px;text-align: start; padding: 10px;" v-if="isDisabled">
                      <div style="margin-top: 10px;">
                        <div>办理结果:  我已完成了，后续麻烦继续跟进一下。</div>
                      </div>
                      <div style="margin-top: 10px;">
                        <div>回执附件:</div>
                        <div style="margin-left: 11%;" v-for="(itme,index) in FileLists22" :key="index">
                            <div style="margin-bottom: 20px;margin-top: 20px;">
                                <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                            </div>
                        </div>
                      </div>
                      <div style="margin-top: 10px;text-align: end;">
                        <div>处理时间: </div>
                        <div>2024-5-29 16:00</div>
                        <div>2024-5-29 16:00</div>
                      </div>
                  </div>
              </div>
              <el-divider></el-divider>
              <div>
                  <h3 style="margin-bottom: 20px;">教师待办</h3>
                  <i class="el-icon-warning-outline" style="color: rgb(227 14 65); font-size: 80px; position: absolute;  right: 30px; margin-top: -50px;" v-if="isDisabled"></i>
                  <div style="display: flex;margin-bottom: 20px;">
                     <div style="margin-top: 10px;" :style="{ paddingRight: isDisabled ? '23px' : '10px' }">{{ isDisabled  ? '待办人' : '选择人员' }}:  </div>
                     <div>
                        <el-select :disabled="isDisabled" placeholder="请选择助理" v-model="value3" style="width: 100%" clearable filterable>
                          <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                        </el-select>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;">
                     <div style="margin-top: 10px;padding-right: 10px;">待办内容:</div>
                     <div style="width: 85%;">
                       <el-input :disabled="isDisabled" type="textarea"  placeholder="请输入内容"  v-model="textarea3" maxlength="200" :autosize="{ minRows: 6, maxRows: 6 }"  show-word-limit></el-input>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;">
                     <div style="margin-top: 5px;padding-right: 10px;">{{ isDisabled  ? '附件' : '上传附件' }}:</div>
                     <div style=""  v-if="!isDisabled">
                        <el-button type="primary" size="small" @click="handleUptaFlie(3)">请选择附件<i class="el-icon-upload el-icon--right"></i></el-button>
                     </div>
                  </div>
                  <div style="display: flex; margin-bottom: 20px;" v-if=" FileLists3 && FileLists3.length > 0">
                     <div style="margin-left: 11%;" v-for="(itme,index) in FileLists3" :key="index">
                        <div style="margin-bottom: 20px;margin-top: 20px;">
                            <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                            <i style="color: #f31341;" class="el-icon-close" @click="handleDelet(itme,index,3)"></i>
                        </div>
                     </div>
                  </div>
                  <div style="margin-bottom: 20px; background: #e9e9e9; margin-top: 30px;text-align: start; padding: 10px;" v-if="isDisabled">
                      <div style="margin-top: 10px;">
                        <div>办理结果:  我已完成了，后续麻烦继续跟进一下。</div>
                      </div>
                      <div style="margin-top: 10px;">
                        <div>回执附件:</div>
                        <div style="margin-left: 11%;" v-for="(itme,index) in FileLists33" :key="index">
                            <div style="margin-bottom: 20px;margin-top: 20px;">
                                <span style="color: #0c8adf;margin-right: 20px;" @click="handleShow(itme,index)">{{itme.name}}</span>
                            </div>
                        </div>
                      </div>
                      <div style="margin-top: 10px;text-align: end;">
                        <div>处理时间: </div>
                        <div>2024-5-29 16:00</div>
                        <div>2024-5-29 16:00</div>
                      </div>
                  </div>
              </div>
              <el-divider></el-divider>


              <div>
                <el-button  v-if="!isDisabled" type="primary" size="small" @click="handlePreserve('取消')">取消<i class="el-icon-close el-icon--right"></i></el-button>
                <el-button  v-if="!isDisabled" type="primary" size="small" @click="handlePreserve('发布保存')">发布/保存<i class="el-icon-check el-icon--right"></i></el-button>
              </div>

        </el-dialog>



        
        <el-dialog title="上传附件" width="50%" style="padding: 50px 50px;" :visible.sync="uploadShowDlong" :before-close="uploadShowDlongCler" :close-on-click-modal="false">
            <el-upload class="upload-demo" style="height: 350px;"
                drag
                action="#"
                :on-remove="handleRemove"
                :beforeUpload="beforeUpload"
                :http-request="handleUpload"
                :on-error="handleError"
                :auto-upload="true"
                :limit="50"
                show-file-list
                :file-list="fileDataList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler">取消</el-button>
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub">保存</el-button>
            </div>
        </el-dialog>


        <el-dialog title="请假事由" width="50%" style="padding: 0px 50px;" :visible.sync="showReasonForLeave" :before-close="showReasonForLeaveCler" :close-on-click-modal="false">
            <div style="padding: 10px; text-align: start;text-indent: 2em;">{{ reasonForLeaveConten }}</div>
        </el-dialog>    

        <el-dialog title="审批流程" width="50%" style="padding: 0px 50px;" :visible.sync="showFlowChart" :before-close="showFlowChartCler" :close-on-click-modal="false">
            <div>

                <div>滕家俊 提交</div>
                <div>2024-05-29 14:16</div>

                <div style="display: flex;justify-content: center;">
                    <div style="width: 2px; background: #27c0f5; height: 80px; text-align: center; margin: 10px 0px;"></div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <div style="color: red;">
                        <div>A领导 审批</div>
                        <div>2024-05-30 15:16</div>
                    </div>
                    <div style="margin-left: 30px;color: #1a99e6;">
                        <div>B领导 审批</div>
                        <div>2024-05-29 16:16</div>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <div style="width: 2px; background: rgb(177 183 185); height: 80px; text-align: center; margin: 10px 0px;"></div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <div style="">
                        <div>A领导 审批</div>
                    </div>
                    <div style="margin-left: 30px;">
                        <div>B领导 审批</div>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <div style="width: 2px; background: rgb(177 183 185); height: 80px; text-align: center; margin: 10px 0px;"></div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <div style="">
                        <div>A领导 抄送</div>
                    </div>
                    <div style="margin-left: 30px;">
                        <div>B领导 抄送</div>
                    </div>
                </div>


            </div>
        </el-dialog>  


    </div>
   </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
export default {
  
    data() {
      return {

            showReasonForLeave: false,
            showFlowChart: false,

            reasonForLeaveConten:'先生如晤：昨夜寒风大起，小的偶感风寒。身体稍有不适，晨起头晕目眩，念今不得至，故掷此书明吾意，望先生体恤，小的感激涕零。',

            showPopUpNotification:false,
            textarea1:'',
            fileDataList:[],


            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            input6: '',

            optionList1: [],
            optionList2: [],
            optionList3: [],

            optionList7:[
                { realname:'全部待办', id:1},
                { realname:'助理未完成待办', id:2},
                { realname:'销售未完成待办', id:3},
                { realname:'教师未完成待办', id:4},
                { realname:'未完成待办（整条待办未完成）', id:5},
                { realname:'已完成待办（整条待办已完成）', id:6},
                { realname:'未发布待办', id:7},
            ],

            input7: 1,

            pageNum: 1,
            pageSize: 10,
            total: 0,

            dataList: [],


            ShowAddTemplateDialog: false,
            ShowAddTemplateDialogTltie: '添加模版',

            content: '',
            showComponents:false,

            disabled:false,


            types:'初始化',
            templateId:'',

        
            uploadShowDlong:false,
            listFile1:[],
            listFile2:[],
            listFile3:[],

            isDisabled:false,

            value1:'',
            textarea1:'',
            FileLists1:[],

            value2:'',
            textarea2:'',
            FileLists2:[],

            value3:'',
            textarea3:'',
            FileLists3:[],

            boom: 0,

            FileLists11:[],
            FileLists22:[],
            FileLists33:[],

      };
    },
  
    mounted() {
      this.handleGetApiAll()
    },  
    
    methods:{

      showReasonForLeaveCler(){
        this.showReasonForLeave = false
      },  

      showFlowChartCler(){
        this.showFlowChart = false
      },  

      handleUptaFlie(boom){
         this.boom = boom
         this.uploadShowDlong = true
      },

      handlePreserve(type){
         if(type === '取消'){
            this.showPopUpNotification = false
            this.value1 = ''
            this.textarea1 = ''
            this.FileLists1 = []

            this.value2 = ''
            this.textarea2 = ''
            this.FileLists2 = []

            this.value3 = ''
            this.textarea3 = ''
            this.FileLists3 = []
         }
         if(type === '发布保存'){

            let isBoole = true 
            if(this.value1){
              if(this.textarea1 || this.FileLists1.length > 0){
               
               }else{
                 isBoole = false
                 this.$message({type: 'warning', message: '请填写（助理待办）内容或上传附件' })
              }
            }

            if(this.value2){
              if(this.textarea2 || this.FileLists2.length > 0){ 

              }else{
                 isBoole = false
                 this.$message({type: 'warning', message: '请填写（销售待办）内容或上传附件' })
              }
            }

            if(this.value3){
              if(this.textarea3 || this.FileLists3.length > 0){ 

              }else{
                 isBoole = false
                 this.$message({type: 'warning', message: '请填写（教师待办）内容或上传附件' })
              }
            }

            if(isBoole){
              console.log('发布成功~')
            }

         }
      },

      uploadShowDlongCler(){
        this.fileDataList = []
        this.uploadShowDlong = false
     },

      uploadShowDlongSub(){
        if(this.boom === 1){
           this.FileLists1 = [...this.FileLists1,...this.fileDataList]
        }
        if(this.boom === 2){
           this.FileLists2 = [...this.FileLists2,...this.fileDataList]
        }
        if(this.boom === 3){
           this.FileLists3 = [...this.FileLists3,...this.fileDataList]
        }
       
        this.uploadShowDlong = false
        this.fileDataList = []
      },


      handleDelet(itme,index,bomm){
        if(bomm === 1){
           this.FileLists1 = this.FileLists1.slice(0, index).concat(this.FileLists1.slice(index + 1))
        }
        if(bomm === 2){
           this.FileLists2 = this.FileLists2.slice(0, index).concat(this.FileLists2.slice(index + 1))
        }
        if(bomm === 3){
           this.FileLists3 = this.FileLists3.slice(0, index).concat(this.FileLists3.slice(index + 1))
        }
     
      },
      
      handleShow(ImgObj){
            let { url } = ImgObj
            let ele = document.createElement('a')
            ele.setAttribute('href', url)
            document.body.appendChild(ele)
            ele.click()
      },


      handleGetApiAll(){
            axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
               this.optionList1 = res.data.data
               this.optionList2 = res.data.data
               this.optionList3 = res.data.data
            })

            // this.dataList = [{ addPeople:'岁岁平岁岁安·岁岁平安', addTime:'2024-05-10', TemplateName:'邮箱模版', applyTemplate:'是' }]

            this.handleGeiApiFindTemplatePage()

        },


        handleGeiApiAddTemplate(){
            let data = {  name: '邮箱模版',   content: this.content, }
            let types = this.types === '初始化' ? 'addTemplate' : 'modifyTemplate/' + this.templateId
            axios.post(`${apiBaseUrl}/template/${types}`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                   this.$message({type: 'success', message: '添加成功'})
                   this.handleGeiApiFindTemplatePage()
                   this.showComponents = false
                   this.ShowAddTemplateDialog = false
               }else{
                   this.$message({type: 'error', message: '添加失败' })
               }
            })
        },


        handleGeiApiFindTemplatePage(){
            let data = {  name: this.input3, pageNum: this.pageNum,  pageSize: this.pageSize , createId: this.input1, createStartDate: this.input2.length > 0 ? this.input2[0] : '', createEndDate: this.input2.length > 0 ? this.input2[1] : ''}
            axios.post(`${apiBaseUrl}/template/findTemplatePage`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
               if(res.data.code == 200){
                    let data = res.data.data
                    this.dataList = data.records
                    this.total = data.total
                    this.pageSize = data.size
                    this.pageNum = data.current
                    this.$message({type: 'success', message: '查询成功'})
               }else{
                    this.$message({type: 'error', message: '查询失败' })
               }
            })
        },



        handleAddCilckTemplate(type){
            if(type === '邮箱模版'){
                this.showComponents = true
            }
        },

        AddexportBtnss(){
            this.types = '初始化'
            this.ShowAddTemplateDialog = true
        },



        handleShowAddTemplateDialogClose(){
            this.showComponents = false
            this.ShowAddTemplateDialog = false
        },


        handleShowAddTemplateDialogSub(){
            this.handleGeiApiAddTemplate()
        },


        searchBtns(){
            this.handleGeiApiFindTemplatePage()
        },

        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input6 = ''

            this.pageNum = 1
            this.pageSize  = 10

            this.handleGeiApiFindTemplatePage()
        },

        handleClickView(type,row){
            console.log(row)
            let { templateId, name, content } = row
            
            if(type === '详情'){
               this.types = '详情'
               this.disabled = true
               this.showComponents = true
               this.ShowAddTemplateDialog = true
               this.content = content
               this.templateId = templateId

            }
            if(type === '编辑'){
               this.isDisabled = false
               this.showPopUpNotification = true
            }

            if(type === '发布'){
               this.isDisabled = false
               this.showPopUpNotification = true
            }

            if(type === '删除'){
              this.$confirm("此操作将删除当前行内容, 是否继续?", "提示", {  confirmButtonText: "确定",   cancelButtonText: "取消",  type: "warning",}).then(() => {
                  this.$message({type: "success",message: "删除成功~",  })
              }).catch(() => {
                  this.$message({type: "warning",message: "已取消~",  })
              })
            }

            if(type === '待办状态'){
               this.isDisabled = true
               this.showPopUpNotification = true
            }

            if(type === '请假事由'){
                this.showReasonForLeave = true
            }

            if(type === '审批流程'){
               this.showFlowChart = true
            }

        },


        showPopUpNotificationCler(){
           this.showPopUpNotification = false
        },


        handleCurrentChange(Current){
            this.pageNum = Current
            this.handleGeiApiFindTemplatePage()
        },

        handleSizeChange(Size){
            this.pageSize = Size
            this.handleGeiApiFindTemplatePage()
        },



        handleRemove(file, fileList){
            this.fileDataList = fileList
        },

        getFileName(name) {
             return name.substring(name.lastIndexOf("."))
        },

        beforeUpload(file, fileList){
            loadingUtils.startLoading()
            const fileExtensions = this.getFileName(file.name) === ".pdf" || 
                this.getFileName(file.name) === ".bmp" ||
                this.getFileName(file.name) === ".tif" ||
                this.getFileName(file.name) === ".gif" ||
                this.getFileName(file.name) === ".pcx" ||
                this.getFileName(file.name) === ".svg" ||
                this.getFileName(file.name) === ".psd" ||
                this.getFileName(file.name) === ".webp" ||
                this.getFileName(file.name) === ".apng" ||
                this.getFileName(file.name) === ".ai" ||
                this.getFileName(file.name) === ".avif" ||
                this.getFileName(file.name) === ".png" ||
                this.getFileName(file.name) === ".pdf"||
                this.getFileName(file.name) === ".mp4"||
                this.getFileName(file.name) === ".excel"||
                this.getFileName(file.name) === ".doc"||
                this.getFileName(file.name) === ".ppt"||
                this.getFileName(file.name) === ".mp3"||
                this.getFileName(file.name) === ".xls"||
                this.getFileName(file.name) === ".xlsx"||
                this.getFileName(file.name) === ".pptx"||
                this.getFileName(file.name) === ".docx"||
                this.getFileName(file.name) === ".txt"||
                this.getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                this.$message({type: 'warning', message: '格式不符合要求，请上传有效格式~' })
                loadingUtils.endLoading()
            }

            return fileExtensions && max20M
        },
        handleUpload(option){
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = option.file.name
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()

                let replacedStr = res.name.replace("mz_pc/", "")
                res.name =  replacedStr

                this.fileDataList.push(res)

                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        },

        handleError(){
            loadingUtils.endLoading()
        },


    }


    
};
</script>

<style scoped lang="less">
      .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }

    .box{
        position: fixed;
        background: #f3f3f3;
        width: 100%;
        z-index: 1111;
        top: 0;
        left: 0;
        height: 100vh;
        margin: 0;
    }

   /deep/ .ql-blank{
        height: 75vh;
   }

   .no-click {
      pointer-events: none;
    }
</style>
  


// WEBPACK FOOTER //
// src/AnonymousLetterManagement/LeaveApprovalManagement.vue